import React from 'react';
import styled from 'styled-components';
import { IconPiggy as IconPiggyStatic } from '../Misc/Piggy';
const Wrapper = styled.div `
  position: relative;
  display: table;
  animation: piggy 2s ease infinite;

  @keyframes piggy {
    27.5%,
    45%,
    100% {
      transform: none;
    }
    35% {
      transform: translateY(1px);
    }
  }
`;
const Clip = styled.div `
  left: 30%;
  right: 30%;
  bottom: 70%;
  position: absolute;
  overflow: hidden;
  height: 24px;

  &:before,
  &:after {
    content: '';
    width: 8px;
    height: 8px;
    box-shadow: inset 0 0 0 1.75px var(--icon-color, currentColor);
    border-radius: 50%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    top: 19px;
  }

  &:before {
    animation: coin 2s ease infinite;
  }

  &:after {
    opacity: 0;
    transform: translate(-50%, -24px);
    animation: coin-second 2s ease infinite;
  }

  @keyframes coin {
    5% {
      transform: translate(-50%, 0);
    }
    25%,
    45% {
      transform: translate(-50%, 8px);
      opacity: 1;
    }
    45.1%,
    46% {
      opacity: 0;
    }
    45.5% {
      transform: translate(-50%, -24px);
    }
    65% {
      opacity: 1;
    }
    80%,
    100% {
      transform: translate(-50%, 0);
    }
  }

  @keyframes coin-second {
    10% {
      opacity: 0;
      transform: translate(-50%, -24px);
    }
    40% {
      opacity: 1;
      transform: translate(-50%, 8px);
    }
    45.5% {
      opacity: 0;
      transform: translate(-50%, 8px);
    }
    100% {
      opacity: 0;
      transform: translate(-50%, -24px);
    }
  }
`;
const Piggy = styled(IconPiggyStatic) `
  & > path {
    opacity: 0;
  }
`;
export const IconPiggy = (props) => {
    return (React.createElement(Wrapper, { className: props.className },
        React.createElement(Clip, null),
        React.createElement(Piggy, null)));
};
//# sourceMappingURL=Piggy.js.map